import React from 'react'
import {Grid} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import get from 'lodash/get'
import style from './imagepartitionlayout.module.css'

function ImagePartitionLayout(props){
    const ContentComponent = get(props,"ContentComponent",null);
    const title = get(props,"title","");
    const subtitle = get(props,"subtitle","");
    return (
        <Grid container className={style.image_partition_layout_container} direction={"row"}>
            <Grid item sm={6} md={6} lg={8} className={style.image_partition_img_container}>
                <Grid container className={style.image_partition_text_container} direction={"column"}>
                   <Grid item className={style.image_partition_text_title}>
                       {title}
                   </Grid>
                    <Grid item className={style.image_partition_text_subtitle}>
                        {subtitle}
                    </Grid>
                </Grid>
                <div className={style.image_partition_shadow}>

                </div>
            </Grid>
            <Grid item sm={6} md={6} lg={4} className={style.image_partition_form_container} component={Paper} elevation={10} square>
                    {ContentComponent}
            </Grid>
        </Grid>
    )
}

export default ImagePartitionLayout